// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 4/13/2023 4:09:17 PM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

export enum GetInitialStateEnum {}

export enum GetFederalHolidayListEnum {}

export enum PersistHolidayListEnum {}

export enum DeleteHolidayEnum {
  companyIdCanNotBeEmpty = 0,
}

export enum PersistPersonVacationBalanceEnum {
  personIdCanNotBeEmpty = 0,
  companyIdCanNotBeEmpty = 1,
}

export enum GetPersonVacationBalanceEnum {
  personIdCanNotBeEmpty = 0,
  companyIdCanNotBeEmpty = 1,
}

export interface GetInitialStateRequestInterface {
  companyId: number;
}

export interface GetStatutoryHolidayListRequestInterface {
  companyId: number;
}

export interface GetStatutoryHolidayListResponseInterface {
  relevantStates: string[];
  statutoryHolidayList: Array<HolidayInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetInitialStateResponseInterface {
  canSkipStatPayCalculationMethod: string;
  holidayList: Array<HolidayInterface>;
  eligibilityEarningsCriteriaList: Array<EligibilityEarningsCriteriaInterface>;
  allowedStatPayCalculationMethodList: Array<StatPayCalculationMethodInterface>;
  validationResults: ValidationResultsInterface;
  statutoryHolidaysSettingsAvailable: boolean;
  statutoryHolidaysCalculationType: number;
}

export enum MethodTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  federal = 2,
  daily = 3,
  noAutomaticCalculation = 4,
}

export interface GetFederalHolidayListRequestInterface {}

export interface GetFederalHolidayListResponseInterface {
  holidayList: Array<HolidayInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PersistHolidayListRequestInterface {
  holidayList: Array<HolidayInterface>;
}

export interface PersistHolidayListResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface DeleteHolidayRequestInterface {
  holiday: HolidayInterface;
}

export interface DeleteHolidayResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface EligibilityEarningsCriteriaInterface {
  id: number;
  provinceId: number;
  provinceName: string;
  eligibilityCriteria: string;
  earningsCalculation: string;
  isFedaralMethodCompliant: boolean;
}

export interface HolidayInterface {
  id?: number;
  name: string;
  date: string;
  hoursPerDay: number;
  isFederal?: boolean;
  stateCalendarList: Array<string>;
  isInPayPeriod: boolean;
  defaultHoursPerDay: number;
  applicableForAllStates: boolean;
}

export interface StatPayCalculationMethodInterface {
  id: number;
  name: string;
  isActive: boolean;
}

export interface PersistPersonVacationBalanceRequestInterface {
  personId: number;
  companyId: number;
  jobVacationBalanceList: Array<JobVacationBalanceInterface>;
}

export interface PersistStatHolidaysCalculationMethodRequestInterface {
  companyId: number;
  calculationMethodType?: number;
}

export interface PersistPersonVacationBalanceResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface PersistStatHolidaysCalculationMethodResponseInterface {
  validationResults: ValidationResultsInterface;
  selectedCalculationMethod: number;
}

export interface GetPersonVacationBalanceRequestInterface {
  personId: number;
  companyId: number;
}

export interface PersistDailyMethodHoursRequestInterface {
  companyId: number;
  name: string;
  date: string;
  hoursPerDay: number;
}

export interface PersistDailyMethodHoursResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetPersonVacationBalanceResponseInterface {
  jobVacationBalanceList: Array<JobVacationBalanceInterface>;
  validationResults: ValidationResultsInterface;
}

// export interface StateCalendarInterface {
//   id: number;
//   stateId: number;
//   stateShortName: string;
//   name: string;
// }

export interface JobVacationBalanceInterface {
  jobId: number;
  vacationBalance: number;
  vacationEarned: number;
  vacationUsed: number;
  jobStateId: number;
  title: string;
  isPrimary: boolean;
  vacationCalculationType: number;
  stateName: string;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class HolidayPayAccessService {
  getInitialState(request: GetInitialStateRequestInterface): Promise<GetInitialStateResponseInterface> {
    return Post('/PayrollHolidayPayAccess/GetInitialState', request);
  }

  getFederalHolidayList(
    request: GetFederalHolidayListRequestInterface
  ): Promise<GetFederalHolidayListResponseInterface> {
    return Post('/PayrollHolidayPayAccess/getFederalHolidayList', request);
  }

  getStatutoryHolidayList(
    request: GetStatutoryHolidayListRequestInterface
  ): Promise<GetStatutoryHolidayListResponseInterface> {
    return Post('/PayrollHolidayPayAccess/GetStatutoryHolidays', request);
  }

  persistDailyMethodHours(
    request: PersistDailyMethodHoursRequestInterface
  ): Promise<PersistDailyMethodHoursResponseInterface> {
    return Post('/PayrollHolidayPayAccess/PersistDailyMethodHours', request);
  }

  persistHolidayList(request: PersistHolidayListRequestInterface): Promise<PersistHolidayListResponseInterface> {
    return Post('/PayrollHolidayPayAccess/persistHolidayList', request);
  }

  deleteHoliday(request: DeleteHolidayRequestInterface): Promise<DeleteHolidayResponseInterface> {
    return Post('/PayrollHolidayPayAccess/deleteHoliday', request);
  }

  persistPersonVacationBalance(
    request: PersistPersonVacationBalanceRequestInterface
  ): Promise<PersistPersonVacationBalanceResponseInterface> {
    return Post('/PayrollHolidayPayAccess/persistPersonVacationBalance', request);
  }

  persistStatHolidaysCalculationMethod(
    request: PersistStatHolidaysCalculationMethodRequestInterface
  ): Promise<PersistStatHolidaysCalculationMethodResponseInterface> {
    return Post('/PayrollHolidayPayAccess/PersistStatHolidaysCalculationMethod', request);
  }

  getPersonVacationBalance(
    request: GetPersonVacationBalanceRequestInterface
  ): Promise<GetPersonVacationBalanceResponseInterface> {
    return Post('/PayrollHolidayPayAccess/getPersonVacationBalance', request);
  }
}

export default new HolidayPayAccessService();
